export const environment = {
  production: true,
  apiUrl: 'http://localhost:8000/api',
  demo: true
};
